const dataComunidad = [
  {
    clase: 'labibliotecadecristy',
    nombre: 'La biblioteca de Cristy',
    link: 'https://www.instagram.com/labibliotecadecristy/',
    arroba: '@labibliotecadecristy',
    traduccion: 'cristy',
    descripcion: 'El Club de lectura infantil León de biblioteca, de Lima Perú, está dirigido a niños de 3 a 12 años. Allí se realizan actividades de lectura, arte y escritura con propósito. El club está dirigido por Cristy La Barrera, maestra de educación primaria y amante de la literatura infantil y juvenil. En el taller los niños despiertan el gusto por la lectura con libros que tienen una cuota de humor, desarrollan su espíritu artístico con las ilustraciones de los libros álbum y despiertan su habilidad de escritores con los proyectos de investigación.',
  },

  {
    clase: 'curuba',
    nombre: 'Curuba & Cocuyo',
    link: 'https://www.instagram.com/curubaycocuyo/',
    arroba: '@curubaycocuyo',
    traduccion: 'curuba',
    descripcion: 'CURUBA & COCUYO es un proyecto lúdico y educativo para familias colombianas en el exterior que quieren mantener viva su herencia cultural y conservar el uso del español como segunda lengua en casa. Este proyecto es el resultado de la experiencia de María Inés McCormick, periodista y escritora de literatura infantil, como madre colombiana criando a sus hijas en un país de habla no hispana.',
  },

  {
    clase: 'thomasysumundo',
    nombre: 'Thomas y su mundo',
    link: 'https://www.instagram.com/thomasysumundo/',
    arroba: '@thomasysumundo',
    traduccion: 'thomas',
    descripcion: 'Thomas y su mundo es un proyecto que nació del interés de su creador Thomas Escalante por la lectura, con la idea de compartir la magia de los libros con familiares y amigos, grandes y pequeños. Para que la lectura no quede solo en un libro se crean actividades con base en estos para expandir y aprovechar sus aprendizajes.',
  },

  {
    clase: 'elparaguaspodcast',
    nombre: 'El paraguas',
    link: 'https://www.instagram.com/elparaguaspodcast/',
    arroba: '@elparaguaspodcast',
    traduccion: 'el_paraguas',
    descripcion: 'El paraguas pódcast es un espacio de conversaciones alrededor de la literatura infantil y juvenil (LIJ) y la mediación de lectura en casa. Bajo este Paraguas se encuentran tres especialistas y fanáticas de la LIJ: Marcela Escovar, Lina Rojas y Zully Pardo.',
  },



  {
    clase: 'vuelalibros',
    nombre: 'Vuela entre libros',
    link: 'https://www.instagram.com/vuelaentrelibros/',
    arroba: '@vuelaentrelibros',
    traduccion: 'vuela_libros',
    descripcion: 'Vuela entre libros es un proyecto que busca fortalecer las capacidades de los niños, niñas y adolescentes, desarrollando procesos de lectura, escritura y oralidad mediante la creación de espacios no convencionales a través de una mochila viajera itinerante que genera espacios alrededor del arte y la cultura en diferentes sectores diversos de la zona Urbana y Rural de la ciudad de Ibagué.',
  },

  {
    clase: 'conandres',
    nombre: '123 Andrés',
    link: 'https://123andres.com/',
    arroba: '@123conandres',
    traduccion: 'andres',
    descripcion: '123 Andrés es un proyecto musical con una propuesta divertida e interactiva para niños y familias. Es liderado por Andrés Salguero y Christina Sanabria quienes han sido ganadores del Latin Grammy 2016 en la categoría de  Mejor Álbum Para Niños. 123 Andrés se presenta por todo EEUU y en Latinoamérica.',
  },

  {
    clase: 'otrocuento',
    nombre: 'Otro Cuento en la U',
    link: 'https://www.youtube.com/playlist?list=PL9mel2Kt7l9Y47nArvOkj5umgf8j9m68Z',
    arroba: '@bibliotecauniandes',
    traduccion: 'otro_cuento',
    descripcion: 'Otro Cuento en la U es un club de lectura virtual, para familias, niños y niñas hispanohablantes o aprendices de español, en todo el mundo. En el club se leen y adaptan historias clásicas de diferentes culturas, libros ilustrados o álbumes para niñas y niños. Asimismo, realizan manualidades y pequeñas obras de arte después de cada lectura, para que los asistentes compartan con sus familiares.',
  },




  // {
  //   clase: 'vocesencantadas',
  //   link: 'https://www.instagram.com/vocesencantadas/',
  //   arroba: '@vocesencantadas',
  //   descripcion: 'Voces encantadas es un podcast de lectura en voz alta con un toque de actuación en donde aparece Nidawi, el hada del bosque y alter ego de su creadora. Ella tiene una gran cantidad de historias para contar de sus viajes, donde ha encontrado príncipes que cuidan del bosque de niebla, perros que buscan apagar la luna y gallinas que reproducen noticias falsas. Nidawi narra las historias tal y como las ha visto, e invita a sus Shaqeeqers a hacer voces con ella. Andrea Cerón Bermúdez, creadora del podcast, es administradora de empresas y desde pequeña le encantaba grabar su voz y junto con su hermano inventaban cuentos e historias que quedaban plasmados en casetes. Después de hacer algunos talleres de voz y doblaje, se aventuró a hacer su podcast.',
  // },

  

  // {
  //   clase: 'micorazonencasa',
  //   link: 'https://www.instagram.com/micorazonencasa/',
  //   arroba: '@micorazonencasa',
  //   descripcion: 'Mi corazón en casa es un espacio donde podrás encontrar actividades, experimentos, libros, ciencia, artes y música e información útil para padres que buscan conocer herramientas que ayuden a facilitar el camino a la educación en el hogar. En éste lugar su creadora Eli, mamá homeschooler, comparte su camino, su vida cotidiana y sus experiencias basadas en un aprendizaje autodidacta.',
  // },
]

export default dataComunidad